import Header from "@/components/header";
import ListItemLoading from "@/components/loading/listItemLoading/listItemLoading";
import { NoResult } from "@/components/noResult";
import CustomerItem from "@/modules/customer/list/components/customerItem";
import SearchBox from "@/modules/customer/list/components/searchBox";
import {
  ActionIcon,
  Button,
  Center,
  Container,
  Group,
  Loader,
  Stack,
  Text,
  Title
} from "@mantine/core";
import { IconAddressBook, IconPlus } from "@tabler/icons-react";
import React, { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useGetCustomers from "./hooks/useGetCustomers";

function MobileCustomers() {
  const [search, setSearch] = useState<string>("ddd");

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetCustomers({
      term: search,
      count: 10,
      skip: 0,
      enabled: true,
    });



  const observer = useRef<IntersectionObserver | null>(null);

  const lastCustomerElementRef = useCallback(
    (node: HTMLDivElement) => {
      if (isFetchingNextPage) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {

        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );
  const handleSearchChange = (e: string) => {
    if (e.length >= 3) {
      setSearch(e);
    } else if (e.length === 0) {
      setSearch("");
    }
  };

  const navigate = useNavigate();

  return (
    <>
      <Header
        title="مشتریان"
        showBack
        customComponent={
          <>
            {/* <CustomLink
              to="/dashboard/profile/importContact"
              style={{ textDecoration: "none" }}
            >
              <NavLink
                label="افزودن مخاطبین از تلفن همراه"
                color="gray"
                leftSection={
                  <ActionIcon variant="subtle" c="gray">
                    <IconAddressBook />
                  </ActionIcon>
                }
              />
            </CustomLink> */}
            <Group>
              <Button
                px="xs"
                variant="default"
                leftSection={<IconPlus size={14} />}
                onClick={() => navigate("add")}
              >
                افزودن
              </Button>

              <ActionIcon variant="default" size="lg" onClick={() => navigate("/dashboard/profile/importContact")} >
                <IconAddressBook stroke={1} />
              </ActionIcon>
            </Group>

          </>

        }
      />
      <Container w="100%" size="md" bg="white">
        <Title order={4}>مشتریان</Title>
        <Text size="sm" pt="xs">
          مشاهده، اضافه کردن، ویرایش و حذف اطلاعات مشتری خود.
        </Text>
        <Stack mt="md" justify="start" flex={1}>
          <SearchBox setSearch={handleSearchChange} />
          {isLoading ? (
            <ListItemLoading count={4} />
          ) : (
            <>
              {/* {data?.pages.length !== 0 ? (
                <Group>
                  <Badge variant="dot" color="blue" size="lg" radius="xl">
                    تعداد کل : {data?.pages[0].count}
                  </Badge>
                </Group>
              ) : null} */}
              {data?.pages[0].count === 0 && <NoResult />}

              <Stack>
                {data?.pages.map((page, pageIndex) => (
                  <React.Fragment key={pageIndex}>
                    {page?.result?.map((customer, customerIndex) =>
                      page?.result?.length === customerIndex + 1 ? (
                        <div ref={lastCustomerElementRef}>
                          <CustomerItem
                            key={customer?.id}
                            customer={customer}
                          />
                        </div>
                      ) : (
                        <CustomerItem key={customer?.id} customer={customer} />
                      )
                    )}
                  </React.Fragment>
                ))}
                {isFetchingNextPage && (
                  <Center>
                    <Loader type="dots" />
                  </Center>
                )}
              </Stack>
            </>
          )}
        </Stack>
      </Container>
    </>
  );
}

export default MobileCustomers;
